import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Link } from 'react-router-dom';
import MyComponent from './MyComponent';
import Beats from './screens/Beats';
import Services from './screens/Services';
import ContactMe from './screens/ContactMe';
import Vol1 from './screens/Vol1';
import Vol2 from './screens/Vol2';
import Shop from './screens/Shop';
import Vol3 from './screens/Vol3';
import Vol4 from './screens/Vol4';
import { getImageUrl } from './services/r2Service';

// Preload component to start loading images early
const ImagePreloader: React.FC = () => {
  useEffect(() => {
    // Preload volume cover images
    const imageUrls = [
      getImageUrl('vol1.jpg'),
      getImageUrl('vol2.jpeg'),
      getImageUrl('vol3.jpg'),
      getImageUrl('vol4.png')
    ];

    imageUrls.forEach(url => {
      const img = new Image();
      img.src = url;
    });
  }, []);

  return null;
};

const App: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <Router>
      <ImagePreloader />
      <div>
        <nav className="navbar">
          <Link className="nav-link" to="/">Home</Link>
          <Link className="nav-link" to="/beats">Beat&nbsp;Tapes</Link>
          <Link className="nav-link" to="/services">Services</Link>
          <Link className="nav-link" to="/contact-me">Contact</Link>
          <Link className="nav-link" to="/shop">Shop</Link>
        </nav>

        <Routes>
          <Route path="/beats" element={<Beats />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact-me" element={<ContactMe />} />
          <Route path="/Vol2" element={<Vol2 searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
          <Route path="/Vol3" element={<Vol3 searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
          <Route path="/Vol4" element={<Vol4 searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
          <Route path="/" element={<MyComponent />} />
          <Route path="/Vol1" element={<Vol1 searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;



// import Production from './screens/Production'
// import ListenNow from './screens/ListenNow'

{/* <Link className="nav-link" to="/production">Production</Link> */}
{/* <Link className="nav-link" to="/listen-now">Listen&nbsp;Now</Link> */}